import { sendBeacon } from "@helpers/webBeacon"
import { route } from "ziggy-js"
import {
  currentProductInteractionPlatform,
  ProductInteractionType,
} from "@shared/models/ProductInteraction/ProductInteraction"

interface SendProductInteractionParams {
  productId: string
  collectionId?: string
  type: ProductInteractionType
  tag?: string
}

export const sendProductInteraction = ({ productId, collectionId, type, tag }: SendProductInteractionParams) => {
  const data = new window.FormData()
  data.append("product_id", productId)
  if (collectionId) {
    data.append("collection_id", collectionId)
  }
  data.append("type", type)
  data.append("platform", currentProductInteractionPlatform)
  if (tag) {
    data.append("tag", tag)
  }

  sendBeacon(route("merchant.product-interactions.store"), data)
}
